import * as React from "react";
import { SVGProps } from "react";

import theme from "../../../../Theme/theme";

const HistoryPlanificationPrep: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  const { fill = theme.palette.primary.dark } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={70}
      height={70}
      viewBox="0 0 70 70"
      {...props}
    >
      <defs>
        <pattern
          id="pattern"
          preserveAspectRatio="xMidYMid slice"
          width="100%"
          height="100%"
          viewBox="0 0 222 222"
        >
          <image
            width={222}
            height={222}
            xlinkHref="data:image/png;base64,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"
          />
        </pattern>
      </defs>
      <g
        id="Groupe_147"
        data-name="Groupe 147"
        transform="translate(0.03 -0.307)"
        opacity={1}
      >
        <g id="Groupe_141" data-name="Groupe 141" transform="translate(0 0)">
          <rect
            id="horloge_gris"
            width={70}
            height={70}
            rx={14}
            transform="translate(-0.03 0.307)"
            fill={fill}
          />
        </g>
        <rect
          id="icone_planning_blanc"
          width={43}
          height={42}
          transform="translate(13.97 14.307)"
          fill="url(#pattern)"
        />
      </g>
    </svg>
  );
};
export default HistoryPlanificationPrep;
